enum WatermarkPosition {
  CENTER = 'ce',
  NORTH = 'no',
  SOUTH = 'so',
  EAST = 'ea',
  WEST = 'we',
  NORTH_EAST = 'noea',
  NORTH_WEST = 'nowe',
  SOUTH_EAST = 'soea',
  SOUTH_WEST = 'sowe',
  REPLICATE = 're',
}

export default WatermarkPosition;
